/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react/prop-types */
/* eslint-disable import/no-extraneous-dependencies */

import React, { useCallback } from "react";
import PropTypes from "prop-types";
import AsyncSelect from "react-select/async";
import { Typography } from "@mui/material";
import debounce from "lodash/debounce";

const LocationPickerAsync = ({
  labelObj = { label: "Location", name: "location" },
  selectedLocation = null,
  handleChange = () => {},
  setFieldValue = () => {},
}) => {
  // Map API data to React-Select options
  const filterLocation = (data) =>
    data?.map((loc) => ({
      label: loc.name,
      value: loc._id,
      region: loc?.geoLocationData?.region,
      city: loc?.geoLocationData?.city,
    }));

  const promiseOptions = (inputValue) =>
    new Promise((resolve) => {
      let url = `${process.env.REACT_APP_API}/locations?`;
      url += `${inputValue ? `&name=${inputValue}` : ""}`;
      url += "&sort=name&dir=asc";
      setTimeout(() => {
        fetch(url)
          .then((response) => response.json())
          .then((result) => {
            resolve(filterLocation(result.data));
          })
          .catch((error) => console.log(error));
      }, 800);
    });

  const debouncedLoadOptions = debounce((inputValue, callback) => {
    promiseOptions(inputValue)
      .then((options) => callback(options))
      .catch((err) => console.error(err));
  }, 800);

  const handleSelectChange = useCallback(
    (option) => {
      setFieldValue(labelObj.name, option);
      handleChange(option);
    },
    [labelObj.name, setFieldValue, handleChange]
  );

  const getPlaceholder = () => {
    if (selectedLocation?.label || selectedLocation === null) {
      return selectedLocation.label;
    }
    return "Search for a Location";
  };

  return (
    <div>
      <Typography style={{ wordBreak: "break-word", fontSize: "0.875rem", fontWeight: 400 }}>
        {labelObj.label}
      </Typography>
      <AsyncSelect
        cacheOptions
        defaultOptions
        placeholder={getPlaceholder()}
        // value={location}
        menuPosition="fixed"
        loadOptions={debouncedLoadOptions}
        onChange={handleSelectChange}
        components={{
          DropdownIndicator: () => null,
          IndicatorSeparator: () => null,
        }}
        styles={{
          control: (base) => ({
            ...base,
            height: "40px",
          }),
          menuPortal: (base) => ({
            ...base,
            zIndex: 9999,
          }),
          input: (base) => ({
            ...base,
            fontSize: "0.875rem",
          }),
          menuList: (base) => ({
            ...base,
            fontSize: "0.875rem",
          }),
          placeholder: (base) => ({
            ...base,
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            // overflow: "hidden",
            maxWidth: "100%",
            WebkitLineClamp: 1,
            fontSize: "0.875rem",
          }),
          singleValue: (base) => ({
            ...base,
            fontSize: "0.875rem",
            overflow: "unset",
          }),
        }}
      />
    </div>
  );
};

LocationPickerAsync.propTypes = {
  labelObj: PropTypes.shape({
    label: PropTypes.string,
    name: PropTypes.string,
  }),
  selectedLocation: PropTypes.instanceOf(Object),
  handleChange: PropTypes.func,
  setFieldValue: PropTypes.func,
};

export default LocationPickerAsync;
